import { type SxProps, type Theme } from "@mui/material";
import { Text, type TextProps } from "@src/appV2/redesign/system/ui-components";

import { type CancellationProtectionDescription } from "./utils/getCancellationProtectionDescription";

interface SegmentedTextProps {
  segments: CancellationProtectionDescription;
  variant?: TextProps["variant"];
  sx?: SxProps<Theme>;
}

export function SegmentedText(props: SegmentedTextProps) {
  const { segments, variant = "body2", sx } = props;

  return (
    <Text variant={variant} sx={sx}>
      {segments.map((segment, index) =>
        segment.bold ? (
          // eslint-disable-next-line react/no-array-index-key -- Static text segments
          <Text key={index} inline bold variant={variant} sx={{ color: "inherit" }}>
            {segment.text}
          </Text>
        ) : (
          segment.text
        )
      )}
    </Text>
  );
}
